import { STATE_INITIAL } from 'Store/commonActions';

import { DEFAULT_LANGUAGE, REDUCER_KEY_LANGUAGE, REDUCER_KEY_MESSAGE } from './constants';
import type { I18nState } from './types';

const initialState: I18nState = {
  [REDUCER_KEY_MESSAGE]: STATE_INITIAL,
  [REDUCER_KEY_LANGUAGE]: DEFAULT_LANGUAGE,
};

export default initialState;
